import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsertDetailDirective } from './insert-detail.directive';
import { HeaderStylesDirective } from './header-styles.directive';
import { InstagramSrcDirective } from '../directives/instagram-src.directive';
import { SelectDirective } from './select.directive';
import { DropdownDirective } from './dropdown.directive';
import { HiddeBtnSlideDirective } from './hidde-btn-slide.directive';

const declarations = [
  InsertDetailDirective,
  HeaderStylesDirective,
  InstagramSrcDirective,
  SelectDirective,
  DropdownDirective,
  HiddeBtnSlideDirective,
];

@NgModule({
  declarations,
  imports: [CommonModule],
  exports: declarations,
})
export class DirectivesModule {}
